enum CountryCode {
    Canada = 'CAN',
    USA = 'USA',
}

export default CountryCode;
